import React from 'react';

import type { ReactNode } from 'react';
import type { ViewProps } from 'react-native';

import { Container } from './styles';

interface ContentProps extends ViewProps {
  children: ReactNode;
  align?: "flex-start" | "center" | "flex-end";
}

export default function ContentButton({ children, align = 'center' }: ContentProps) {
  return <Container align={align}>{children}</Container>;
}
